import { render, staticRenderFns } from "./NotificationEmailForm.vue?vue&type=template&id=9569176c&scoped=true"
import script from "./NotificationEmailForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationEmailForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9569176c",
  null
  
)

export default component.exports